// Shopify checkout address input fields
const addressForm = {
    firstName: {
        query: '#first-name',
        maxLen: 20,
        valid: true,
    },
    lastName: {
        query: '#last-name',
        maxLen: 20,
        valid: true,
    },
    email: {
        query: '#email',
        maxLen: 150,
        valid: true,
    }
};

var addressSubmitBtnEl;

const isFormValid = () => {
    const isInvalid = (addressInput) => !addressInput.valid;

    return !Object.values(addressForm).some(isInvalid);
};

const disableAddressSubmit = (addressInput) => {
    if (!addressInput.valid) {
        return;
    }

    addressInput.valid = false;
    addressSubmitBtnEl.disabled = true;
    addressSubmitBtnEl.style.opacity = 0.6;
};

const enableAddressSubmit = (addressInput) => {
    if (addressInput.valid) {
        return;
    }

    addressInput.valid = true;

    if (isFormValid()) {
        addressSubmitBtnEl.disabled = false;
        addressSubmitBtnEl.style.opacity = 1;
    }
};

const setInputError = (addressInput, addressInputEl, theErrorMessage) => {
    if (!addressInput.valid) {
        return;
    }
    if (document.querySelector('.error-message')) {
        return;
    }

    const firstNameDiv = document.querySelector('.register-form.fifty.first-name');
    if (firstNameDiv) {
        addressInputEl.style.borderColor = 'red';
        const errorMessageEl = document.createElement('div');

        errorMessageEl.innerHTML = theErrorMessage;
        errorMessageEl.className = 'error-message';
        errorMessageEl.style.display = 'block';
        errorMessageEl.style.marginTop = '20px';
        errorMessageEl.style.color = '#ec5578';
        errorMessageEl.style.lineHeight = 'normal';

        firstNameDiv.parentNode.insertBefore(errorMessageEl, firstNameDiv);
    }
};

const removeInputError = (addressInput, addressInputEl) => {
    if (addressInput.valid) {
        return;
    }
    addressInputEl.style.borderColor = '#d9d9d9';
    const errorMessageEl = document.querySelector('.error-message');

    if (errorMessageEl) {
        errorMessageEl.remove();
    }
};

const validateNonLatin = (addressInput, addressInputEl, addressInputLen) => (
    (event) => {
        if (event.target.value.length === addressInputLen) {
            event.preventDefault();
            const errorMessage = 'You have reached maximum charatcter of ' + addressInputLen + ' allowed for the field!';
            setInputError(addressInput, addressInputEl, errorMessage);

            return disableAddressSubmit(addressInput);
        }

        removeInputError(addressInput, addressInputEl);

        return enableAddressSubmit(addressInput);
    }
);

const asciiOnly = () => {
    Object.values(addressForm).forEach((addressInput) => {
        const addressInputEl = document.querySelector(addressInput.query);

        const addressInputLen = addressInput.maxLen;

        if (addressInputEl) {
            addressInputEl.setAttribute("maxlength", addressInputLen);

            const onInputUpdate = validateNonLatin(addressInput, addressInputEl, addressInputLen);

            addressInputEl.addEventListener('input', onInputUpdate);
            // For address autocomplete automatically filling up city field
            addressInputEl.addEventListener('change', onInputUpdate);
        }
    });
    const addressSubmitBtn = 'input.button.button--block.button--secondary';
    addressSubmitBtnEl = document.querySelector(addressSubmitBtn);
};

// document.addEventListener('DOMContentLoaded', asciiOnly);
// window.addEventListener('load', asciiOnly);
window.onload = function () {
    asciiOnly();
};